import { useState } from 'react';
import { Button as MuiButton } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { Confirm, Toolbar, useRecordContext, useSaveContext } from 'react-admin';

export const AdsWriteSettingsToolbar = () => {
  const { save } = useSaveContext();
  const { handleSubmit } = useFormContext();
  const record = useRecordContext();
  const [pending, setPending] = useState(null);

  const handleSave = handleSubmit((values) => {
    if (record && record.kill_switch && values.kill_switch === false) {
      setPending(values);
    } else {
      save(values);
    }
  });

  return (
    <Toolbar>
      <MuiButton variant="contained" onClick={handleSave}>Save</MuiButton>
      <Confirm
        isOpen={!!pending}
        title="Turn the kill switch off?"
        content="Approved actions will be handed to the scripts within the hour."
        onConfirm={() => {
          save(pending);
          setPending(null);
        }}
        onClose={() => setPending(null)}
      />
    </Toolbar>
  );
};
